import { sessionStore } from './session.store';

/**
 * 세션 리셋 레지스트리.
 * 사용자별 상태를 가진 store · 캐시는 `onSessionReset` 에 자기 초기화 함수를 등록한다.
 * 리셋할 목록을 여러 곳에 손으로 나열하지 않는다.
 */
type ResetHandler = () => void;

const handlers = new Set<ResetHandler>();

export function onSessionReset(handler: ResetHandler): () => void {
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}

/** 등록된 사용자별 상태(쿼리 캐시 · store · 오버레이 등)를 모두 비운다. 세션 상태는 건드리지 않는다. */
export function clearUserState(): void {
  for (const handler of handlers) {
    try {
      handler();
    } catch {
      // 한 곳의 실패가 나머지 초기화를 막지 않게 한다.
    }
  }
}

/** 로그아웃 · 세션 만료 때 부른다. 등록된 상태를 모두 비우고 게스트로 만든다. */
export function resetSession(): void {
  clearUserState();
  sessionStore.getState().setGuest();
}
